import { RoutesDefinition, RouteDefinition } from '@features/routing/RouteDefinitions';
import { DEFAULT_LANGUAGE } from '@@/languageConfig';



export const AppRoutes: RoutesDefinition = {
	CZ: {
		basePath: '/',
		admin: 'admin',
		article: 'article',
		about: 'o-nas',
		history: 'nase-historie',
		order: 'chci-objednat',
		orderSelect: 'chci-objednat-vyber',
		catOrder: 'chci-objednat-kocka',
		catProbe: 'chci-objednat-jicnova-sonda',
		gallery: 'galerie',
		partners: 'pro-partnery',
		partnersRegistration: 'registrace-pro-partnery',
		partnersOrder: 'objednavka-pro-partnery',
		faq: 'nejcastejsi-dotazy',
		contact: 'kontakt',
		salesNetwork: 'prodejni-sit',
		thankYouOrder: 'dekujeme-za-objednavku',
		thankYouRegistration: 'dekujeme-za-registraci',
	},
	SK: {
		basePath: '/',
		admin: 'admin',
		article: 'article',
		about: 'o-nas',
		history: 'nasa-historia',
		order: 'chcem-objednat',
		orderSelect: 'chcem-objednat-vyber',
		catOrder: 'chcem-objednat-macka',
		catProbe: 'chcem-objednat-pazerakova-sonda',
		gallery: 'galeria',
		partners: 'pre-partnerov',
		partnersRegistration: 'registracia-pre-partnerov',
		partnersOrder: 'objednavka-pre-partnerov',
		faq: 'najcastejsie-otazky',
		contact: 'kontakt',
		salesNetwork: 'predajna-siet',
		thankYouOrder: 'dakujeme-za-objednavku',
		thankYouRegistration: 'dakujeme-za-registraciu',
	},
	DE: {
		basePath: '/',
		admin: 'admin',
		article: 'article',
		about: 'uber-uns',
		history: 'unsere-geschichte',
		order: 'ich-mochte-bestellen',
		orderSelect: 'ich-mochte-bestellen-auswahl',
		catOrder: 'ich-mochte-bestellen-katze',
		catProbe: 'ich-mochte-bestellen-osophagussonde',
		gallery: 'galerie',
		partners: 'fur-partner',
		partnersRegistration: 'registrierung-fur-partner',
		partnersOrder: 'bestellung-fur-partner',
		faq: 'haufig-gestellte-fragen',
		contact: 'kontakt',
		salesNetwork: 'vertriebsnetz',
		thankYouOrder: 'danke-fur-die-bestellung',
		thankYouRegistration: 'danke-fur-die-registrierung',
	},
} as const;



export const NavigateRoutes: RouteDefinition = {
	basePath: AppRoutes[DEFAULT_LANGUAGE].basePath,
	admin: `/${AppRoutes[DEFAULT_LANGUAGE].admin}`,
	article: `/${AppRoutes[DEFAULT_LANGUAGE].article}`,
	about: `/${AppRoutes[DEFAULT_LANGUAGE].about}`,
	history: `/${AppRoutes[DEFAULT_LANGUAGE].history}`,
	order: `/${AppRoutes[DEFAULT_LANGUAGE].order}`,
	orderSelect: `/${AppRoutes[DEFAULT_LANGUAGE].orderSelect}`,
	catOrder: `/${AppRoutes[DEFAULT_LANGUAGE].catOrder}`,
	catProbe: `/${AppRoutes[DEFAULT_LANGUAGE].catProbe}`,
	gallery: `/${AppRoutes[DEFAULT_LANGUAGE].gallery}`,
	partners: `/${AppRoutes[DEFAULT_LANGUAGE].partners}`,
	partnersRegistration: `/${AppRoutes[DEFAULT_LANGUAGE].partnersRegistration}`,
	partnersOrder: `/${AppRoutes[DEFAULT_LANGUAGE].partnersOrder}`,
	faq: `/${AppRoutes[DEFAULT_LANGUAGE].faq}`,
	contact: `/${AppRoutes[DEFAULT_LANGUAGE].contact}`,
	salesNetwork: `/${AppRoutes[DEFAULT_LANGUAGE].salesNetwork}`,
	thankYouOrder: `/${AppRoutes[DEFAULT_LANGUAGE].thankYouOrder}`,
	thankYouRegistration: `/${AppRoutes[DEFAULT_LANGUAGE].thankYouRegistration}`,
} as const;